import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Card,
  CardContent,
  Grid,
  Link,
  Typography,
} from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { CheckCircle } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";

// Contexts
import DomainContext from "../../../context/domains/DomainContext";

// Components
import DomainEdit from "./DomainEdit";

const DomainList = ({ handleEdit, handleUpdate }) => {
  const useStyles = makeStyles(() => ({
    card: {
      marginBottom: 18,
    },
  }));
  const classes = useStyles();

  const { domains, domains_filtered, selected_index, verifyDomain } =
    useContext(DomainContext);

  const per_page = 5;
  const [data, setData] = useState(null); // loaded data
  const [total_data, setTotalData] = useState(0); // full data length
  const [total_loaded, setTotalLoaded] = useState(0); // loaded data length

  const refresh = async (name) => {
    await verifyDomain(name);
    handleUpdate();
  };

  const loadMore = () => {
    setTotalLoaded(total_loaded + per_page);
  };

  useEffect(() => {
    if (domains_filtered) {
      setData(domains_filtered);
      setTotalData(domains_filtered.length);
    } else if (domains) {
      setData(domains);
      setTotalData(domains.length);
    }

    setTotalLoaded(per_page);
  }, [domains, domains_filtered]);

  return (
    <Grid item>
      {" "}
      {/* Loading */}{" "}
      {!data ? (
        <Skeleton
          variant="rect"
          width="100%"
          height="110px"
          className={classes.card}
        />
      ) : (
        data.map((domain, index) => {
          return (
            index < total_loaded && (
              <Card key={index} className={classes.card}>
                {" "}
                {/* Edit & Listing */}{" "}
                {selected_index === index ? (
                  <DomainEdit
                    handleEdit={handleEdit}
                    handleUpdate={handleUpdate}
                  />
                ) : (
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid
                        item
                        container
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Grid item>
                          <Typography variant="h6">
                            <Link
                              href={`https://${domain.name}`}
                              target="_blank"
                              underline="none"
                            >
                              {domain.name}{" "}
                            </Link>{" "}
                          </Typography>{" "}
                        </Grid>
                        <Grid item>
                          <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => refresh(domain.name)}
                          >
                            Refresh{" "}
                          </Button>{" "}
                          &emsp;{" "}
                          <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => handleEdit(index, domain)}
                          >
                            Edit{" "}
                          </Button>{" "}
                        </Grid>{" "}
                      </Grid>
                      <Grid
                        item
                        container
                        spacing={2}
                        alignItems="center"
                        justifyContent="flex-start"
                      >
                        {domain.verified && (
                          <Grid item xs={4}>
                            <Typography variant="body1">
                              <CheckCircle />&ensp; Valid Configuration{" "}
                            </Typography>{" "}
                          </Grid>
                        )}{" "}
                        <Grid item xs={8}>
                          <Typography variant="body1">
                            DNS Target : {domain.dns_target}{" "}
                          </Typography>{" "}
                        </Grid>
                      </Grid>{" "}
                    </Grid>{" "}
                  </CardContent>
                )}{" "}
              </Card>
            )
          );
        })
      )}
      {/* Load More Button */}{" "}
      {total_loaded < total_data && (
        <Button
          variant="outlined"
          color="primary"
          size="large"
          fullWidth
          onClick={loadMore}
        >
          LOAD MORE{" "}
        </Button>
      )}{" "}
    </Grid>
  );
};

export default DomainList;
